import React from "react";
import Button from "../../extra/Button";
import { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Table from "../../extra/Table";
import {
  getGift,
  deleteGift,
} from "../../store/gift/gift.action";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import GiftDialog from "./GiftDialog";
import { warning } from "../../../util/Alert";
import Pagination from "../../extra/Pagination";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { colors } from "../../../util/SkeletonColor";
import { useState } from "react";
import Iconb from "../../extra/Iconb";
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import defaultImage from "../../../assets/images/default.jpg";

const Gift = (props) => {
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const { gift } = useSelector((state) => state.gift);
  const { dialogue, dialogueType } = useSelector(
    (state) => state.dialogue
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGift());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(gift);
  }, [gift]);

  // pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  // Delete Gift
  const handleDelete = (id) => {
    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          dispatch(deleteGift(id));
        }
      })
      .catch((err) => console.log(err));
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => <span className="text-white fw-normal">{page * rowsPerPage + index + 1}</span>,
    },
    {
      Header: "Icon",
      body: "icon",
      Cell: ({ row }) => (
        <>
          {loading ? (
            <>
              <Skeleton
                height={50}
                width={50}
                style={{ borderRadius: "8px", cursor: "pointer" }}
                className="StripeElement "
                baseColor={colors?.baseColor}
                highlightColor={colors?.highlightColor}
              />
            </>
          ) : (
            <>
              <img
                src={row.icon}
                style={{ borderRadius: "8px", cursor: "pointer" }}
                height={50}
                width={50}
                alt="gift"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
            </>
          )}
        </>
      ),
    },
    {
      Header: "Name",
      body: "name",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-white fw-normal">{row.name || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Price (Coins)",
      body: "price",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-white fw-normal">{row.price} coins</p>
        </div>
      ),
    },
    {
      Header: "Category",
      body: "category",
      Cell: ({ row }) => (
        <div className="">
          <span className="badge bg-info text-dark" style={{ padding: '6px 12px', textTransform: 'capitalize' }}>
            {row.category}
          </span>
        </div>
      ),
    },
    {
      Header: "Rarity",
      body: "rarity",
      Cell: ({ row }) => (
        <div className="">
          <span
            className={`badge ${
              row.rarity === 'legendary' ? 'bg-warning' :
              row.rarity === 'epic' ? 'bg-purple' :
              row.rarity === 'rare' ? 'bg-primary' : 'bg-secondary'
            }`}
            style={{ padding: '6px 12px', textTransform: 'capitalize' }}
          >
            {row.rarity}
          </span>
        </div>
      ),
    },
    {
      Header: "Animation",
      body: "animationType",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-white fw-normal" style={{ textTransform: 'capitalize' }}>
            {row.animationType}
          </p>
        </div>
      ),
    },
    {
      Header: "Order",
      body: "order",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-white fw-normal">{row.order}</p>
        </div>
      ),
    },
    {
      Header: "Status",
      body: "isActive",
      Cell: ({ row }) => (
        <div className="">
          <span
            className={`badge ${row.isActive ? 'bg-success' : 'bg-danger'}`}
            style={{ padding: '6px 12px' }}
          >
            {row.isActive ? 'Active' : 'Inactive'}
          </span>
        </div>
      ),
    },
    {
      Header: "Edit",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",
          }}
          isImage={true}
          onClick={() => {
            dispatch({
              type: OPEN_DIALOGUE,
              payload: { data: row, type: "Gift" },
            });
          }}
        />
      ),
    },
    {
      Header: "Delete",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter killbtn userBtn fs-5`}
          btnIcon={<DeleteIcon sx={{ color: '#FF4C51' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",
            padding: "0px"
          }}
          isImage={true}
          isDeleted={true}
          onClick={() => handleDelete(row?._id)}
        />
      ),
    },
  ];

  return (
    <>
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Gift Management</div>
          <div className="sellerMain">
            <div className="tableMain mt-2 categoryTable">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-12">
                    <Button
                      newClass={`whiteFont`}
                      btnColor={`btnBlackPrime `}
                      btnIcon={`fa-solid fa-plus `}
                      btnName={`Add Gift`}
                      onClick={() => {
                        dispatch({
                          type: OPEN_DIALOGUE,
                          payload: { type: "Gift" },
                        });
                      }}
                      style={{ borderRadius: "5px", padding: "8px 32px", background: "#F0C420" }}
                    />
                    {dialogue && dialogueType === "Gift" && <GiftDialog />}
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                PerPage={rowsPerPage}
                Page={page}
                type={"client"}
              />
              <Pagination
                component="div"
                count={gift?.length}
                serverPage={page}
                type={"client"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={gift?.length}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{display : "flex", justifyContent : "start"}}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getGift,
  deleteGift,
})(Gift);
